function scrollEvent() {
	var $header = document.querySelector('.header'),
		headerTopHeight = document.querySelector('.header__top').offsetHeight,
		$scrollToTop = document.querySelector('.scroll-to-top');

	window.addEventListener('scroll', function() {
		var scrollTop = window.pageYOffset;

		if(scrollTop >= headerTopHeight && !$header.classList.contains('header--fixed')) {

			$header.classList.add('header--fixed');

		} else if($header.classList.contains('header--fixed') && scrollTop < headerTopHeight) {

			$header.classList.remove('header--fixed');

		}

		if(scrollTop > window.innerWidth) {
			$scrollToTop.classList.add('active');
		} else {
			$scrollToTop.classList.remove('active');
		}

	});
};

module.exports = scrollEvent;